export {
  STEP_STATUS,
  OPERATION_PHASE,
  OUTCOME,
  ERROR_KIND,
  SIMPLE_SUCCESS_TOAST_MS,
  createClientOperationId,
  isConfirmedStepSuccess,
  hasMeaningfulErrors,
} from "./types";

export {
  getOperationCoordinator,
  getCoordinator,
  OperationCoordinator,
  __resetOperationCoordinatorForTests,
} from "./operationCoordinator";

import { getOperationCoordinator } from "./operationCoordinator";

/** Clear OF dialogs + toast queue on logout / session teardown. */
export function clearSessionFeedback() {
  getOperationCoordinator().clearSession();
}

export {
  promangToast,
  enqueueToast,
  dismissToast,
  shouldSuppressToastForOperation,
  getSnapshot as getToastQueueSnapshot,
  getToastSessionGeneration,
  subscribe as subscribeToastQueue,
  __resetToastQueueForTests,
  onVisibleToastRemoved,
  flushToastQueue,
  clearAllToasts,
  resumeSessionPresentation,
  isPresentationSuspended,
} from "./toastQueue";

export { normalizeError, classifyHttpSuccess } from "./normalizeError";

export {
  READINESS_STATUS,
  isReadinessSignal,
  canConfirmStepFromEvidence,
  mapServerStepStatus,
  aggregateOperationOutcome,
  outcomeAfterRefreshFailure,
} from "./progressInvariants";

export {
  OperationActionDialog,
  OperationFeedbackHost,
} from "./OperationActionDialog";

export { TechnicalErrorDetails } from "./TechnicalErrorDetails";

export {
  sanitizeDiagnosticsForUi,
  formatDiagnosticsCopyText,
  DIAGNOSTICS_COPY_ALLOWLIST,
} from "./diagnosticsSanitize";

export {
  dispatchWithToast,
  dispatchWithToastV2,
  dispatchWithToastPromise,
  axiosWithToast,
} from "./legacyToastAdapters";
